import React from 'react';

import ContactCard from 'Core/Components/ContactCard';

import { scrollToTop } from 'Core/Utils/DomUtils';
import SocialNav from 'Core/Components/SocialNav';
import PublicStore from 'Site/State/Store';
import NavList from 'Site/Ui/NavList';

class Footer extends React.Component {
  constructor (props) {
    super(props);
    const { meta } = PublicStore.getState();
    this.state = { meta };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }

  componentDidMount () {
    this.unsubscribe = PublicStore.subscribe(() => {
      const { meta } = PublicStore.getState();
      this.setState({ meta });
    });
  }

  componentWillUnmount () {
    this.unsubscribe();
  }

  render () {
    const { meta } = this.state;
    const { location } = this.props;
    const { contacts, socials } = meta;
    const contactList = contacts.map(contact => (
      <box className="xs-12 md-3" key={contact.name}>
        <h4 className="section-heading">{contact.name}</h4>
        <ContactCard contact={contact} />
      </box>
    ));

    return (
      <footer className="Footer">
        <div className="pattern-spacer quantized"> </div>
        <grid className="guttered">
          <box className="xs-12 md-2" onClick={() => scrollToTop()}>
            <img src="assets/logo-black.svg" className="footer-logo" />
          </box>
          <box className="xs-12 md-2" onClick={() => scrollToTop()}>
            <NavList className="stack" showAll={true} location={location} />
          </box>
          {contactList}
          <box className="xs-12 md-2">
            <h4 className="section-heading">Connect</h4>
            <SocialNav socials={socials} />
          </box>
        </grid>
      </footer>
    )
  }
};

export default Footer;



// WEBPACK FOOTER //
// ./client/Site/Ui/Footer.jsx